/**
 * ClosingSection Component
 * 
 * ⭐ CENTRALIZED CLOSING SECTION FOR ALL WEDDING PAGES ⭐
 * 
 * This component serves as the single source of truth for all closing section text
 * across the entire wedding website. Changing the default text here will update
 * all pages simultaneously.
 * 
 * Used by: FullAgenda, CombinedAgenda, MainAgenda, Wedding, Reception, 
 *          SangeetNWedding, PrivateAgenda, Timeline, CompactAgenda
 * 
 * Props:
 * - title: Main title text (defaults to centralized text)
 * - subtitle: Subtitle/description text (defaults to centralized text)
 * - variant: Style variant ("default" or "simple")
 * - className: Additional CSS classes for special styling
 * 
 * 📝 To change text on ALL pages, modify the default values below
 */

import React from 'react';

const ClosingSection = ({ 
  title = "We would love to see you there!!", // 📝 EDIT HERE: Changes title on ALL pages
  subtitle = "Your presence will make our special day even more memorable.", // 📝 EDIT HERE: Changes subtitle on ALL pages
  variant = "default",
  className = ""
}) => {
  return (
    <div className={`closing-section ${className}`.trim()}>
      <div className="closing-container">
        {variant === "simple" ? (
          <>
            <h2 className="closing-title">{title}</h2>
            <p className="closing-subtitle">{subtitle}</p>
            <div className="closing-ornament">
              <span className="ornament">💕</span>
              <span className="closing-names">Radhika & Vivek</span>
              <span className="ornament">💕</span>
            </div>
          </>
        ) : (
          <div className="closing-title">
            <h2>{title}</h2>
            <p>{subtitle}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClosingSection;